module.exports = __webpack_public_path__ + "static/media/triwa-watch.163cfc24.jpg";